import React from "react";

const AnswerTable = ({ table }) => {
  const columns = table?.columns ?? [];
  const rows = table?.rows ?? [];

  if (rows.length === 0) {
    return <p className="text-sm italic text-gray-400">No rows</p>;
  }

  const headerCells = columns.length > 0 ? columns : rows[0].map((_, i) => `Column ${i + 1}`);

  return (
    <div className="overflow-x-auto border border-gray-200 rounded">
      <table className="min-w-full text-sm">
        <thead className="bg-gray-50">
          <tr>
            {headerCells.map((col, idx) => (
              <th
                key={`${col}-${idx}`}
                className="px-3 py-2 text-left text-xs font-semibold text-gray-600 uppercase tracking-wide border-b border-gray-200"
              >
                {col}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {rows.map((row, rIdx) => (
            <tr key={rIdx} className={rIdx % 2 === 0 ? "bg-white" : "bg-gray-50"}>
              {headerCells.map((_, cIdx) => {
                const cell = row[cIdx];
                const value = cell?.value ?? "";
                return (
                  <td
                    key={cIdx}
                    className="px-3 py-2 text-gray-900 align-top whitespace-pre-wrap border-b border-gray-100"
                  >
                    {value || <span className="text-gray-400 italic">—</span>}
                  </td>
                );
              })}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default AnswerTable;
